export default __webpack_public_path__ + "static/media/bonus icon.6aa55687.svg";